module.exports = __webpack_public_path__ + "img/RectangleBigFrame.29dbc5ce.png";